import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  Input,
} from "@angular/core";
import { ModalGenericoModel } from "src/app/shared/models/modal.model";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { ActividadEconomicaEntry } from "src/app/shared/entrys/actividad-economica.entry";

@Component({
  selector: "app-modal-actividad-economica",
  templateUrl: "./modal-actividad-economica.component.html",
  styleUrls: ["./modal-actividad-economica.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ModalActividadEconomicaComponent implements OnInit {
  @Input()
  actividadesEconomicas: Array<ActividadEconomicaEntry>;
  tipoUsuario: any;

  headers: Array<string>;
  modalGenerico: ModalGenericoModel;

  constructor(private activeModal: NgbActiveModal) {}

  ngOnInit() {
    this.modalGenerico = {
      titulo: "Actividad económica",
    };
    this.headers = ["Código", "Descripción", "Origen"];
  }

  confirm(): void {
    this.activeModal.close();
  }
}
